import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { getClient } from "services";

import { isSignedIn as getIsSignedIn } from "seneca-common/features/user/state";

export default function useFetchActivationCode() {
  const isSignedIn = useSelector(getIsSignedIn);

  return useQuery(
    ["discord-activation-code"],
    async () => await getClient("discordService").fetchActivationCode(),
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: isSignedIn
    }
  );
}
